export { default } from './loader';